export const DISPLAY_UNITS_FIELD_NAMES = {
  setup_time: 'setupTimeDisplayUnits',
  runtime: 'runtimeDisplayUnits',
};
